<template>
  <div class="increment">
    <div class="increment-page-content">
      <div class="title">就诊流程 质控</div>
      <div class="content">
        <div>
          <a-radio-group @change="onChange" v-model="data.qualityStatus">
            <a-radio :value="1">合格</a-radio>
            <a-radio :value="2">不合格</a-radio>
          </a-radio-group>
          <div v-if="data.qualityStatus == 2" class="increment-textarea">
            <div class="input-message">还可以输入1000个字</div>
            <a-textarea v-model="data.qualityRemark" placeholder="请输入不合格原因......" :rows="4" />
          </div>
        </div>
        <div class="footer">
          <a-button @click="submit()" :loading="btnloading" style="width:100px" type="primary">确定</a-button>
          <a-button
            @click="closeModel"
            style="width:100px;margin-left:16px;"
            class="ant-btn-custom"
          >取消</a-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    data: {
      type: Object,
      default: () => {
        return {
          qualityStatus: 1,
          qualityRemark: ""
        };
      }
    }
  },
  data() {
    return {
      isSubmit: false,
      isHttpSubmit: false,
      radioValue: 1,
      btnloading: false,
      formData: {}
    };
  },
  created() {
    this.data.qualityStatus = 1;
    this.data.qualityRemark = "";
  },
  methods: {
    submit() {
      this.isSubmit = true;
      if (this.data.qualityStatus == 2 && !this.data.qualityRemark) {
        return;
      }
      this.btnloading = true;
      this.$post(
        "patientitem/patientItem/patientItemFolow?operateType=qc",
        this.data,
        {
          "Content-Type": "application/json"
        }
      ).then(
        res => {
          if (res.data.code == 1) {
            this.$message.success("操作成功");
            this.$emit("close");
            this.btnloading = false;
          } else {
            this.$message.error(res.data.message);
            this.btnloading = false;
          }
        },
        () => {
          this.$message.error("操作失败");
        }
      );
    },
    closeModel() {
      this.$emit("close");
    },
    onChange(e) {
    }
  }
};
</script>

<style lang="scss" scoped>
.increment {
  width: 100%;
  height: 100%;
  background: #fff;
  overflow: auto;
  .increment-page-content {
    width: 482px;
    margin: 80px auto 40px;
    .title {
      font-size: 26px;
      font-family: PingFang SC;
      font-weight: 400;
      color: rgba(51, 51, 51, 1);
      margin-bottom: 50px;
    }
    /deep/.content {
      border: 1px solid rgba(243, 245, 247, 1);
      padding: 30px 46px;
      width: 100%;
      .ant-radio-wrapper + .ant-radio-wrapper {
        margin-left: 99px;
      }
      .increment-textarea {
        height: 202px;
        position: relative;
        margin: 22px 0 14px 0;
        .input-message {
          font-size: 12px;
          font-family: PingFang SC;
          font-weight: 400;
          color: rgba(164, 164, 164, 1);
          position: absolute;
          bottom: 10px;
          right: 10px;
          z-index: 2;
        }
        textarea {
          height: 202px;
          resize: none;
        }
      }
    }
    .footer {
      width: 100%;
      margin-top: 20px;
    }
  }
}
</style>